import BackendService from './BackendService';

async function getFailedJobs(params) {
  return BackendService.getData('/failed-jobs/', {}, params);
}
async function syncFiledJobs(data) {
  return BackendService.postData('/failed-jobs/sync/', data);
}

const FailedJobService = {
  getFailedJobs,
  syncFiledJobs,
};

export default FailedJobService;
